// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* .secnav__navbar__home{\n    font-weight: bold;\n}\n.secnav__navbar__allmeasures{\n    font-weight: normal;\n} */\n", "",{"version":3,"sources":["webpack://./src/pages/homepage/homepage.css"],"names":[],"mappings":"AAAA;;;;;GAKG","sourcesContent":["/* .secnav__navbar__home{\n    font-weight: bold;\n}\n.secnav__navbar__allmeasures{\n    font-weight: normal;\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
